/* eslint-disable import/no-extraneous-dependencies */
import { createGlobalStyle } from 'styled-components';
import DINRegular from './DIN-Regular.woff';
import DINBold from './DINBold.woff';
import DINMedium from './DIN-Medium.woff';
import DINMediumAlternate from './DIN-Medium-Alternate.woff';
import LibreBaskervilleRegular from './LibreBaskerville-Regular.woff';
import Baskerville from './baskervi.woff';

import GEAwtarDWTCMedium from './GEAwtarDWTC-Medium.woff';
import GESSTwoBold from './GESSTwoBold-Bold.woff';
import GESSTwoDWTCLight from './GESSTwoDWTC-Light.woff';
import GESSTwoDWTCMedium from './GESSTwoDWTC-Medium.woff';

import URWDINRegular from './URWDIN-Regular.woff';
import URWDINBold from './URWDIN-Bold.woff';
import URWDINMedium from './URWDIN-Medium.woff';

const FontStyles = createGlobalStyle`
    @font-face {
        font-family: 'URWDINRegular';
        font-display: block;
        src: local('URWDINRegular'), local('URWDINRegular'),
        url(${URWDINRegular}) format('woff');
    }
    @font-face {
        font-family: 'URWDINBold';
        font-display: block;
        src: local('URWDINBold'), local('URWDINBold'),
        url(${URWDINBold}) format('woff');
    }
    @font-face {
        font-family: 'URWDINMedium';
        font-display: block;
        src: local('URWDINMedium'), local('URWDINMedium'),
        url(${URWDINMedium}) format('woff');
    }
    @font-face {
        font-family: 'DINRegular';
        font-display: block;
        src: local('DINRegular'), local('DINRegular'),
        url(${DINRegular}) format('woff');
    }
    @font-face {
        font-family: 'DINBold';
        font-display: block;
        src: local('DINBold'), local('DINBold'),
        url(${DINBold}) format('woff');
    }
    @font-face {
        font-family: 'DINMedium';
        font-display: block;
        src: local('DINMedium'), local('DINMedium'),
        url(${DINMedium}) format('woff');
    }
    @font-face {
        font-family: 'DINMediumAlternate';
        font-display: block;
        src: local('DINMediumAlternate'), local('DINMediumAlternate'),
        url(${DINMediumAlternate}) format('woff');
    }
    @font-face {
        font-family: 'LibreBaskervilleRegular';
        font-display: block;
        src: local('LibreBaskervilleRegular'), local('LibreBaskervilleRegular'),
        url(${LibreBaskervilleRegular}) format('woff');
    }
    @font-face {
        font-family: 'Baskerville';
        font-display: block;
        src: local('Baskerville'), local('Baskerville'),
        url(${Baskerville}) format('woff');
    }
    @font-face {
        font-family: 'GEAwtarDWTCMedium';
        font-display: block;
        src: local('GEAwtarDWTCMedium'), local('GEAwtarDWTCMedium'),
        url(${GEAwtarDWTCMedium}) format('woff');
    }
    @font-face {
        font-family: 'GESSTwoBold';
        font-display: block;
        src: local('GESSTwoBold'), local('GESSTwoBold'),
        url(${GESSTwoBold}) format('woff');
    }
    @font-face {
        font-family: 'GESSTwoBoldBold';
        font-display: block;
        src: local('GESSTwoBold'), local('GESSTwoBold'),
        url(${GESSTwoBold}) format('woff');
    }
    @font-face {
        font-family: 'GESSTwoDWTCLight';
        font-display: block;
        src: local('GESSTwoDWTCLight'), local('GESSTwoDWTCLight'),
        url(${GESSTwoDWTCLight}) format('woff');
    }
    @font-face {
        font-family: 'GESSTwoDWTCMedium';
        font-display: block;
        src: local('GESSTwoDWTCMedium'), local('GESSTwoDWTCMedium'),
        url(${GESSTwoDWTCMedium}) format('woff');
    }
`;

export default FontStyles;
